import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export const useSetPosition = (vmRef, stickerRef) => {
  const [isPositionChanged, setIsPostionedChanged] = useState(false);

  useEffect(() => {
    const handlePosition = () => {
      setIsPostionedChanged(false);
      const vmLeftPosition = vmRef.current.children[0].getBoundingClientRect()
        .left;

      if (stickerRef.current) {
        stickerRef.current.style.left = '0px';
        const stickerLeftPosition =
          stickerRef.current.getBoundingClientRect().left - 5;
        stickerRef.current.style.left = `calc(${vmLeftPosition}px - ${stickerLeftPosition}px)`;
        setIsPostionedChanged(true);
      }
    };

    handlePosition();
    window.addEventListener('resize', handlePosition);
    return () => {
      window.removeEventListener('resize', handlePosition);
    };
  }, [vmRef, stickerRef]);

  return isPositionChanged;
};

useSetPosition.propTypes = {
  vmRef: PropTypes.object.isRequired,
  stickerRef: PropTypes.object.isRequired,
};
